import { inspirationCategories } from './consts';
import { InspirationType } from './types';

export default function isValidInspirationCategory(category: unknown): boolean {
  return inspirationCategories.includes(category as InspirationType['category']);
}
